import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DobryAgentBlogCategory, DobryAgentBlogTag} from '../../../../shared/interface/dobry-agent-blog-article';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {AuthService} from '../../../../shared/services/auth.service';
import {DobryAgentBlogCategoryService} from "../../../../shared/services/dobry-agent-blog-category.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-da-category-details-view',
  templateUrl: './da-category-details-view.component.html',
  styleUrls: ['./da-category-details-view.component.scss']
})
export class DaCategoryDetailsViewComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() blogCategory: ReplaySubject<DobryAgentBlogCategory>;
  @Output() modifyClicked = new EventEmitter<void>();

  userPermissions: ReplaySubject<UserPermissions>;
  blogCategoryObject?: DobryAgentBlogCategory;

  constructor(
    private auth: AuthService,
    private dobryAgentBlogCategoryService: DobryAgentBlogCategoryService,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.blogCategory
      .pipe(takeUntil(this.destroyed$))
      .subscribe((category: DobryAgentBlogCategory) => {
        this.blogCategoryObject = category;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }


  delete(blogTag: DobryAgentBlogTag): void {
    this.dobryAgentBlogCategoryService
      .confirmDelete(blogTag)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted: boolean) => {
        if (!deleted) {
          return;
        }

        this.router.navigate([
          '/blog-dobry-agent/kategorie'
        ]);
      });
  }

  deleteWeak(uuid: string): void {
    this.dobryAgentBlogCategoryService
      .confirmDeleteWeak(uuid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted: boolean) => {
        if (!deleted) {
          return;
        }

        this.router.navigate([
          '/blog-dobry-agent/kategorie'
        ]);
      });
  }
}
